<template>
  <div>
    <div class="notice" v-for="(label, index) in labels" :key="index">
      <span v-if="label == 'Предзаказной'">Предзаказ</span>
      <span v-if="label == 'Эксклюзивный'">Эксклюзив</span>
      <span v-if="label != 'Эксклюзивный' && label != 'Предзаказной'">{{label}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "product-labels",
  props:['labels']
}
</script>

<style scoped lang="scss">
.notice {
  color: white;
  border-radius: 4px;
  padding: 7px 5px;
  background: #F39220;
  margin-bottom: 2px;
  text-align: center;
  font-size: 10px;
}
</style>
